import React, { useState, useRef } from 'react'
import PropTypes from 'prop-types'
import { v4 } from 'uuid'
import ReactTooltip from 'react-tooltip'
import { ContentWrapper } from '../styles'

const TooltipSpan = ({
  children,
  backgroundColor,
  place,
  type,
  effect,
  delayHide,
  delayShow,
  delayUpdate,
  closeOnClick,
  content
}) => {
  const tooltipRef = useRef(null)
  const [randomId] = useState(v4())

  return (
    <>
      <span data-tip data-for={`tooltip_${randomId}`}>
        {children}
      </span>
      <ReactTooltip
        id={`tooltip_${randomId}`}
        ref={tooltipRef}
        place={place || 'top'} // top | right | left | bottom
        type={type || 'dark'} // dark | success | warning | error | info | light
        effect={effect || 'solid'} // float | solid
        backgroundColor={backgroundColor}
        delayHide={delayHide || 0}
        delayShow={delayShow || 0}
        delayUpdate={delayUpdate || 0}
        closeOnClick={closeOnClick || false}
      >
        {closeOnClick ? (
          <ContentWrapper
            onClick={() => {
              // ContentWrapper and this onClick function are a hack for close tooltip after a click anywhere inside the tooltip
              tooltipRef.current.tooltipRef = null
              ReactTooltip.hide()
            }}
          >
            {content}
          </ContentWrapper>
        ) : (
          content
        )}
      </ReactTooltip>
    </>
  )
}
TooltipSpan.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.array,
    PropTypes.bool
  ]),
  content: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.array,
    PropTypes.bool
  ]).isRequired,
  place: PropTypes.string,
  type: PropTypes.string,
  effect: PropTypes.string,
  delayHide: PropTypes.number,
  delayShow: PropTypes.number,
  delayUpdate: PropTypes.number,
  backgroundColor: PropTypes.string,
  closeOnClick: PropTypes.bool
}

export default TooltipSpan
